import React from 'react';
import { Switch, Route } from 'react-router-dom';
import ErrorFullPageLazy from 'yoda-app-shell/lib/components/ErrorFullPage/ErrorFullPageLazy';
import PDP from './containers/Pages/PDP/PDP';
import WriteReview from './containers/Pages/WriteReview/WriteReviewPDP';

export default function App() {
    console.log('🌠️ Render App');
    return (
        <>
            <Switch>
                <Route path="/p/review" component={WriteReview} />
                <Route path="/p/:productName/:ppId" component={PDP} />

                {/* when none of the above match, <NoMatch> will be rendered */}
                <Route component={ErrorFullPageLazy} />
            </Switch>
        </>
    );
}
